<template>
    <div ref="stickyHeader" class="case-study-sticky-header w-full h-16 md:h-20 bg-black flex flex-row justify-between items-center px-10 md:px-24 z-50">
        <router-link :to="{path : '/'}">
            <logo class="w-26 h-8" style="fill : white"></logo>
        </router-link>
        <!--<div class="case-study-sticky-header__progress-container w-80 h-2 bg-white overflow-hidden">-->
            <!--<div ref="bar" class="case-study-sticky-header__progress-bar w-0 h-2 bg-greylight"></div>-->
        <!--</div>-->
        <router-link :to="{path : '/'}" class="case-study-sticky-header__link relative block font-signal-regular text-base md:text-2xl text-white tracking-extrawide no-underline h-auto flex-no-grow">Close</router-link>
    </div>
</template>

<script>
    import { TweenMax } from 'gsap';
    import logo from '../assets/svg/designus-logo.svg';

    export default {
        name : 'case-study-sticky-header',

        components : { logo },

        data(){
            return {
                trigger : 200
            }
        },

        mounted(){
            if(document.querySelector('.case-study-sticky-header')) {
                TweenMax.set(document.querySelector('.case-study-sticky-header'), {
                    y : '-100%'
                });
            }

            window.addEventListener('scroll', this.scrollHandler);

        },

        methods : {
            scrollHandler(){
                if(document.querySelector('.case-study-sticky-header')) {
                    TweenMax.to(document.querySelector('.case-study-sticky-header'), 0.4, {
                        y: (window.pageYOffset > this.trigger) ? '0%' : '-100%'
                    });
                }
                // PROGRESS
                // var progress =   ((window.pageYOffset + window.innerHeight) / document.body.clientHeight) * 100;
                //
                // TweenMax.set(this.$refs.bar, {
                //     width : progress + '%'
                // })
            }
        }

    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .case-study-sticky-header {
        position : fixed;
        top : 0;
        left : 0;
        right : 0;
        box-sizing : border-box;

        &__link {
            &::after {
                content : "";
                @include size(calc(100% - 12px), 2px);
                position : absolute;
                bottom : -4px;
                left : 3px;
                background-color : white;
                transition : all 0.4s;

            }

            &:hover {
                &:after {
                    animation-name : linkhoversticky;
                    animation-duration :  0.5s;
                }
            }
        }

        @keyframes linkhoversticky {
            0% {
                width : calc(100% - 12px);
                right : 3px;
                left : auto;
            }

            50% {
                width : 0;
                right : 3px;
                left : auto;
            }

            51% {
                width : 0;
                left : 3px;
                right : auto;
            }

            /*99% {*/
            /*    width : calc(100% - 12px);*/
            /*    left : 0px;*/
            /*    right : auto;*/
            /*}*/

            /*100% {*/
            /*    width : calc(100% - 12px);*/
            /*    right : 0px;*/
            /*    left : auto;*/
            /*}*/
        }
    }
</style>